<template>
  <div
    class="mx-auto"
    style="max-width: 600px"
  >
    <v-card
      rounded="xl"
      elevation="0"
    >
      <v-card-title class="text-h6 font-weight-bold">
        G2E
      </v-card-title>

      <v-card-text>
        <v-row
          dense
        >
          <template v-for="app in apps">
            <v-col
              v-if="$config.isUAT || !app.testingOnly"
              :key="app.desc"
              cols="4"
            >
              <v-card
                flat
                rounded="xl"
                ripple
                color="transparent"
                :to="app.to"
                :href="app.href"
                :target="app.target"
              >
                <div class="py-2 px-5">
                  <v-img
                    :src="app.imgSrc"
                  />
                </div>
                <div
                  class="px-1 pb-2"
                  :class="['text-center', $i18n.locale === 'pt' ? 'ptFontSize' : 'text-body-2']"
                >
                  {{ app.desc }}
                </div>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
  .ptFontSize {
    font-size: 12px;
    line-height: 14px;
  }
</style>

<script>

export default {
  data: function () {
    return {
      appMode: process.env.VUE_APP_MODE
    }
  },
  computed: {
    contactsAppUrl: function () {
      let lang = 'zh-hant'
      if (this.$i18n.locale === 'pt') {
        lang = 'pt'
      }
      let url = `/${lang}/g2e-contacts-app/main/`
      return url
    },
    apps: function () {
      return [
        {
          imgSrc: require('@/assets/ga-icon/icon_address_book.png'),
          desc: this.$t('Main.Contact'),
          href: this.contactsAppUrl
        },
        {
          imgSrc: require('@/assets/ga-icon/icon_Annual_leave.png'),
          to: '/eleave',
          desc: this.$t('Main.Absence')
        },
        {
          imgSrc: require('@/assets/ga-icon/icon_attendance.png'),
          to: '/redirect/attendance?type=attendanceSelf',
          desc: this.$t('Main.Attendance')
        },
        {
          imgSrc: require('@/assets/ga-icon/icon_training.png'),
          to: '/training',
          desc: this.$t('Main.Training')
        },
        {
          imgSrc: require('@/assets/ga-icon/icon_outbox.png'),
          to: '/outbox/Create',
          desc: this.$t('TaskList.Outbox')
        },
        {
          imgSrc: require('@/assets/ga-icon/icon_work.png'),
          to: '/tasklist',
          desc: this.$t('Main.Work')
        }
      ]
    }
  },
  methods: {
  }
}
</script>
